import { render, staticRenderFns } from "./SettingsCheckbox.vue?vue&type=template&id=1b957a3e&scoped=true"
import script from "./SettingsCheckbox.vue?vue&type=script&lang=js"
export * from "./SettingsCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SettingsCheckbox.vue?vue&type=style&index=0&id=1b957a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b957a3e",
  null
  
)

export default component.exports